import { forwardRef, type Ref, type SVGProps } from "react";

function SvgNfcPoster(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={265}
      height={180}
      fill="none"
      {...props}
    >
      <path fill="#F5F5F5" d="M0 0h265v180H0z" />
      <path
        fill="#25272D"
        d="M-6603-8813c0-1.1.9-2 2-2h27996c1.1 0 2 .9 2 2V5317c0 1.1-.9 2-2 2H-6601a2 2 0 0 1-2-2z"
      />
      <path
        fill="#fff"
        fillOpacity={0.1}
        d="M-6601-8814h27996v-2H-6601zm27997 1V5317h2V-8813zm-1 14131H-6601v2h27996zm-27997-1V-8813h-2V5317zm1 1c-.55 0-1-.45-1-1h-2c0 1.66 1.34 3 3 3zm27997-1c0 .55-.4 1-1 1v2c1.7 0 3-1.34 3-3zm-1-14131c.6 0 1 .45 1 1h2c0-1.66-1.3-3-3-3zm-27996-2c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1z"
      />
      <path
        fill="#fff"
        d="M-55-42c0-17.673 14.327-32 32-32h311c17.673 0 32 14.327 32 32v748c0 17.673-14.327 32-32 32H-23c-17.673 0-32-14.327-32-32z"
      />
      <path
        fill="#fff"
        stroke="url(#NfcPoster_svg__a)"
        strokeLinecap="round"
        strokeWidth={13.125}
        d="M45 29.333A9.333 9.333 0 0 1 54.333 20h156.334A9.333 9.333 0 0 1 220 29.333v114.334a9.334 9.334 0 0 1-9.333 9.333H54.333A9.333 9.333 0 0 1 45 143.667z"
      />
      <path
        fill="#fff"
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M161 114a9 9 0 0 1 9-9h18a9 9 0 0 1 9 9v42a9 9 0 0 1-9 9h-18a9 9 0 0 1-9-9z"
      />
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeWidth={2}
        d="M120.949 74.95c2.907 3.198 4.674 7.42 4.674 12.05 0 4.629-1.767 8.851-4.674 12.05m8.42-30.315c4.215 4.939 6.754 11.31 6.754 18.265 0 6.954-2.539 13.326-6.754 18.265m7.516-42.077c6.064 6.361 9.738 14.692 9.738 23.812s-3.674 17.45-9.738 23.812"
      />
      <circle
        cx={179}
        cy={156}
        r={3}
        fill="#fff"
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <defs>
        <linearGradient
          id="NfcPoster_svg__a"
          x1={132.5}
          x2={132.5}
          y1={20}
          y2={153}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#B7DDFF" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgNfcPoster);
export default ForwardRef;
